<template>
  <footer class="bg-gray-900 text-white py-12 border-t border-gray-800">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- Brand -->
        <div class="col-span-1 md:col-span-2">
          <div class="flex items-center gap-2 mb-4">
            <UIcon name="i-heroicons-shield-check" class="text-3xl text-secondary" />
            <span class="text-xl font-bold">ClaimReady</span>
          </div>
          <p class="text-gray-400 max-w-sm">
            Secure, private home inventory reports. Protect your assets with audit-ready documentation.
          </p>
        </div>

        <!-- Quick Links -->
        <div>
          <h3 class="text-sm font-semibold text-gray-200 uppercase tracking-wider mb-4">Quick Links</h3>
          <ul class="space-y-3">
            <li>
              <NuxtLink to="/" class="text-gray-400 hover:text-white transition-colors">Home</NuxtLink>
            </li>
            <li>
              <a href="https://nodeworx.io" target="_blank"
                class="text-gray-400 hover:text-white transition-colors">Nodeworx
              </a>
            </li>
            <li>
              <NuxtLink to="/resources" class="text-gray-400 hover:text-white transition-colors">Resources
              </NuxtLink>
            </li>
          </ul>
        </div>

        <!-- Legal -->
        <div>
          <h3 class="text-sm font-semibold text-gray-200 uppercase tracking-wider mb-4">Legal</h3>
          <ul class="space-y-3">
            <li>
              <NuxtLink to="/privacy" class="text-gray-400 hover:text-white transition-colors">Privacy Policy</NuxtLink>
            </li>
            <li>
              <NuxtLink to="/terms" class="text-gray-400 hover:text-white transition-colors">Terms of Use</NuxtLink>
            </li>
            <li>
              <NuxtLink to="/licenses" class="text-gray-400 hover:text-white transition-colors">Licenses</NuxtLink>
            </li>
            <li><a href="mailto:contact@getclaimready.app"
                class="text-gray-400 hover:text-white transition-colors">Contact
                Support</a></li>
          </ul>
        </div>
      </div>

      <div
        class="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
        <p>&copy; {{ new Date().getFullYear() }} Nodeworx. All rights reserved.</p>
        <p class="mt-2 md:mt-0">Built for privacy and peace of mind.</p>
      </div>
    </div>
  </footer>
</template>
